/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import ProfileCardLink from '../../../../../components/core/ProfileCardLink/ProfileCardLink';
import TableCellEllipsis from '../../../../../components/core/TableCellEllipsis/TableCellEllipsis';
import { PackagingType } from '../../../../../models/core/packaging.type';
import { formatTimestampToString } from '../../../../../utils/formatter.utils';
import DataViewActions from './DataViewActions';

type DataViewProps = {
  data: PackagingType[];
  confirmActionResult(item: PackagingType, action: string, confirmed: boolean): void;
};

export default function DataView(props: DataViewProps) {
  const columns: ColumnsType<any> = [
    {
      title: 'Acondicionamento',
      key: 'residuoAcondicionamento',
      dataIndex: 'residuoAcondicionamento',
      sorter: (a: PackagingType, b: PackagingType) =>
        a.residuoAcondicionamento.localeCompare(b.residuoAcondicionamento),
    },
    {
      title: 'Descrição',
      key: 'descricao',
      sorter: (a: PackagingType, b: PackagingType) => {
        return (a.descricao || '').localeCompare(b.descricao || '');
      },
      render: (row: PackagingType) => (
        <TableCellEllipsis label={row?.descricao} numberOfChars={25} toolTipWidth={300} />
      ),
    },
    {
      title: 'Criado Por',
      key: 'criadoPor',
      sorter: (a: PackagingType, b: PackagingType) => a.criadoPor.localeCompare(b.criadoPor),
      render: (row: PackagingType) => (
        <ProfileCardLink id={row.idCriadoPor} name={row.criadoPor} nameSize="sm" />
      ),
    },
    {
      title: 'Data Criação',
      key: 'dataCriacao',
      sorter: (a: PackagingType, b: PackagingType) =>
        new Date(a.dataCriacao).valueOf() - new Date(b.dataCriacao).valueOf(),
      render: (row: PackagingType) => formatTimestampToString(row.dataCriacao),
    },
    {
      title: 'Modificado Por',
      key: 'modificadoPor',
      sorter: (a: PackagingType, b: PackagingType) =>
        (a.modificadoPor || '').localeCompare(b.modificadoPor || ''),
      render: (row: PackagingType) => {
        if (row.idModificadoPor) {
          return (
            <ProfileCardLink id={row.idModificadoPor || ''} name={row.modificadoPor || ''} nameSize="sm" />
          );
        }
        return '-';
      },
    },
    {
      title: 'Data Modificação',
      key: 'dataModificacao',
      sorter: (a: PackagingType, b: PackagingType) => {
        const date = new Date();
        return new Date(a.dataModificacao || date).valueOf() - new Date(b.dataModificacao || date).valueOf();
      },
      render: (row: PackagingType) => {
        if (row.dataModificacao) {
          return formatTimestampToString(row.dataModificacao);
        }
        return '-';
      },
    },
    {
      title: 'Ações',
      width: '130px',
      render: (row: PackagingType) => (
        <DataViewActions item={row} confirmActionResult={props.confirmActionResult} />
      ),
    },
  ];

  return (
    <Table
      showSorterTooltip={false}
      dataSource={props.data}
      columns={columns}
      rowKey={(item: PackagingType) => item.idResiduoAcondicionamento}
      pagination={{
        pageSizeOptions: [10, 25, 50],
        showSizeChanger: true,
        showTotal: (total, range) => `${range[0]} - ${range[1]} de ${total} resultado(s)`,
      }}
    />
  );
}
